<div class="container-track" [ngClass]="{'first-item': firstItem}">
  <div class="vertical-tracker" [ngClass]="{'vertical-tracker--first-item': firstItem}">
    <div *ngIf="!firstItem" [ngClass]="{'vertical-tracker-line': !completed, 'vertical-tracker-line--done': completed || inProgress, 'vertical-traker-line--inactive': disabled}"></div>
    <div class="outer-dot" [ngClass]="{'outer-dot--simple': simple}">
      <button [ngClass]="{'vertical-tracker__dot': !completed && !disabled, 'vertical-tracker__dot--success': completed, 'vertical-tracker__dot--inactive': disabled, 'vertical-tracker__dot--simple': simple}">
        <span *ngIf="completed && !simple" class="fds-icon fds-font--ford-icons__success"></span>
        <span style="font-size: 1.2rem;" *ngIf="!completed">{{ label }}</span>
      </button>
    </div>
  </div>
  <ng-content class="content"></ng-content>
</div>
